// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadCrumbs_breadcrumbs__CRFth","link":"breadCrumbs_link__s1IcP"};